<template>
  <div class="matrix" 
  :style="{ width: baseSize + 'px', height: baseSize + 'px' }"
  >
    <ul v-for="(row, rowIndex) in matrix" :key="rowIndex">
      <square 
      v-for="(square, colIndex) in row" :key="colIndex" 
      :matrix="matrix"
      :squareData="square"
      v-on="$listeners"
      >
      </square>
    </ul>
  </div>
</template>

<script>
import { baseSize } from '../const'
import { judgeWin } from '../utils/play'
import square from './square'

export default {
  name: 'Matrix',
  props: ['matrix'],
  data () {
    return {
      baseSize
    }
  },
  computed: {
    level () {
      return this.$store.state.level
    }
  },
  watch: {
    // 根据翻开的总数量是否归零来判断是否赢得游戏
    '$store.state.totalCount': {
      handler (totalCount)  {
        judgeWin(totalCount)
      }
    }
  },
  components: {
    square
  }
}
</script>

<style lang="scss" scoped>
$color: rgb(160, 192, 226);
$borderColor: darken($color, 10%);

.matrix {
  display: inline-flex;
  flex-direction: column;
  border: 5px solid rgb(100, 100, 100);
  border-radius: 12px;
  overflow: hidden;
  // cursor: url('../assets/images/pick.32x32.png') 0 10, pointer;

  ul {
    display: flex;
  }

  .mask {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    top: 0; left: 0;
    justify-content: center;
    align-items: center;
    font-size:2rem;
    background: rgba(0,0,0,.3)
  }
}
</style>